import {useSortable} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

export const Competence = ({competence}) => {

    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: competence.id});

    const style = {
        transition,
        transform: CSS.Transform.toString(transform)
    }

    return(
        <Card {...attributes} {...listeners}  style={style} ref={setNodeRef} className="m-2 border-1 rounded dragable">
            <Card.Body>
                <Row className='align-items-center'>
                    <Col md={10} xs={12} className='d-flex align-items-center'>
                        <img src="/images/dragdrop.svg" alt="DragDrop" className='me-3'/> {competence.name}
                    </Col>
                    <Col md={2} xs={12}>
                        <OverlayTrigger placement='bottom' overlay={<Tooltip id={competence.id}>{competence.description}</Tooltip>}>
                            <i className='fas fa-question-circle'/>
                        </OverlayTrigger>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}